import React from 'react';
import { API_URL } from '../../actions';
import { generateKey, isImage } from '../../utils/utils';
import styles from './FilesPreview.module.scss';

export default function FilesPreview({ files = [], name = 'file' }) {
  const list = (files || []).filter(Boolean);
  const imagesList = list.filter((f) => isImage(f?.name));
  const filesList = list.filter((f) => !isImage(f?.name));

  if (!list.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.list}>
        {imagesList.map((f, i) => {
          const url = `${API_URL}/${f?.path}`;
          return (
            <div key={f?._id || generateKey(name, i)} className={styles.image}>
              <a href={url} target="_blank" rel="noreferrer">
                <img src={url} alt={f?.name} />
              </a>
            </div>
          );
        })}
        {filesList.map((f, i) => {
          const url = `${API_URL}/${f?.path}`;
          return (
            <div key={f?._id || generateKey(name, i)} className={styles.file}>
              <a href={url} target="_blank" rel="noreferrer">
                {f?.name || 'fichier'}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}
